import { PostTipoCambioResponse } from "../../bussines/entities/PostTipoCambioResponse.entity";
import { paramsPostTipoCambio } from "../../bussines/params/addEditTipoCambio.params";
import { AddTipoCambioRepository } from "../../bussines/repository/AddTipoCambio.repository";
import { AddTipoCambioExpressProvider } from "../providers/AddTipoCambio.provider";

export class AddTipoCambioDataSource implements AddTipoCambioRepository{
    private AddTipoCambioProvider: AddTipoCambioExpressProvider;
    constructor(apikey:string) {
        this.AddTipoCambioProvider = new AddTipoCambioExpressProvider(apikey);
    }
    postAddTipoCambio(variables:paramsPostTipoCambio): Promise<PostTipoCambioResponse>{
        return this.AddTipoCambioProvider.postAddTipoCambio(variables);
    }
}